import { render, staticRenderFns } from "./SurveyBegin.vue?vue&type=template&id=5338312a&scoped=true&"
import script from "./SurveyBegin.vue?vue&type=script&lang=js&"
export * from "./SurveyBegin.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBegin.vue?vue&type=style&index=0&id=5338312a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338312a",
  null
  
)

export default component.exports